/**
 * Admin "Fetch paid dates" button on the Redemptions page. Limited to these
 * administrators while it is trialled (the backend enforces the same list).
 */
export const PAID_DATE_FETCH_ADMIN_EMAILS = ["yamu@hustle.agency"];

/** Most bills one click may look up in Xero (the backend enforces the same cap). */
export const PAID_DATE_FETCH_MAX_INVOICES = 50;

/** Request body for the fetch, or { error } when the count is out of range. */
export function buildPaidDateFetchRequest(fromDate, limit) {
  const body = {};
  const from = String(fromDate || "").trim();
  if (from) body.fromDate = from;
  const rawLimit = String(limit ?? "").trim();
  if (rawLimit) {
    const n = Number(rawLimit);
    if (!Number.isInteger(n) || n < 1 || n > PAID_DATE_FETCH_MAX_INVOICES) {
      return { error: `Number of bills must be from 1 to ${PAID_DATE_FETCH_MAX_INVOICES}.` };
    }
    body.limit = n;
  }
  return { body };
}

export function canFetchPaidDates(portal, email) {
  if (portal !== "Administrator") return false;
  const normalized = String(email || "").trim().toLowerCase();
  return Boolean(normalized) && PAID_DATE_FETCH_ADMIN_EMAILS.includes(normalized);
}
